<template>
  <nav class="pagination-content shadow-md" role="navigation">

    <ul class="pagination-list">
      <li>
        <a
          class="pagination-link"
          :disabled="currentPage <= startPage || loading"
          @click="toPreviousPage"
          alt="anterior"
        >
          <span>
            Anterior
          </span>
        </a>
      </li>
      <li v-show="hiddenGoToFirst">
        <a
          class="pagination-link"
          :disabled="currentPage <= secondPage || loading"
          @click="toFirstPage"
        >{{ startPage }}</a>
      </li>
      <li v-show="hiddenGoToFirst">
        <span class="pagination-ellipsis">&hellip;</span>
      </li>
      <template v-for="(current, index) in pagesArray">
        <li :key="index">
          <a
            @click="goToPage(current)"
            :class="['pagination-link', { 'is-current': current === currentPage }]"
            :disabled="loading"
          >{{ current }}</a>
        </li>
      </template>
      <li v-show="hiddenToLastPage">
        <span class="pagination-ellipsis">&hellip;</span>
      </li>
      <li v-show="hiddenToLastPage">
        <a
          class="pagination-link"
          :disabled="currentPage >= secondLastPage || loading"
          @click="toLastPage"
        >{{ endPage }}</a>
      </li>
      <li>
        <a class="pagination-link" :disabled="currentPage >= endPage || loading" @click="toNextPage" alt="siguiente">
          Siguiente
        </a>
      </li>
    </ul>

  </nav>
</template>

<script>
import range from 'lodash/range'

export default {
  name: 'BasePagination',
  props: {
    page: {
      type: Number,
      required: true,
      default: 1
    },
    pages: {
      type: Number,
      required: true,
      default: 0
    },
    action: {
      type: Function,
      required: true
    },
    displayPages: {
      type: Number,
      default: 5
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      emptyArray: 0,
      currentPage: 1,
      startPage: 1,
      secondPage: 2
    }
  },
  computed: {
    endPage () { return this.pages },
    secondLastPage () { return this.pages - 1 },
    normalizePagesForArray () { return this.pages + 1 },
    normalizeDisplayPages () { return this.displayPages + 1 },
    hiddenGoToFirst () { return this.currentPage >= 5 },
    hiddenToLastPage () { return this.currentPage <= (this.endPage - 5) },
    pagesArray () {
      const {
        page,
        pages,
        displayPages,
        normalizeDisplayPages,
        startPage,
        normalizePagesForArray
      } = this

      let startRange = this.startPage
      let endRange = this.normalizePagesForArray

      if (pages === startPage) return [1]
      if (pages === startRange) return [startRange]
      if (pages <= displayPages) return range(startRange, endRange)

      if (page >= (normalizePagesForArray - this.displayPages)) {
        startRange = normalizePagesForArray - this.displayPages
        endRange = this.normalizePagesForArray
      } else if (page >= displayPages) {
        startRange = this.isOdd(displayPages) ? (page + 1) - (normalizeDisplayPages / 2) : page - (displayPages / 2)
        endRange = this.isOdd(displayPages) ? page + (normalizeDisplayPages / 2) : page + (displayPages / 2)
      } else {
        endRange = normalizeDisplayPages
      }

      return range(startRange, endRange)
    }
  },
  methods: {
    isOdd (number) { return (number % 2) === 1 },
    toFirstPage () {
      this.goToPage(this.startPage)
    },
    toPreviousPage () {
      this.goToPage(this.currentPage - 1)
    },
    toNextPage () {
      this.goToPage(this.currentPage + 1)
    },
    toLastPage () {
      this.goToPage(this.endPage)
    },
    goToPage (page) {
      if (page !== this.currentPage && !this.loading && page >= this.startPage && page <= this.endPage) {
        this.action(page)
        this.currentPage = page
      }
    },
    pageToIndexArrayValue: (value) => value - 1
  }
}
</script>

<style scoped>
.pagination-content {
  display: block;
  float: right;
  border-radius: .5em;
  overflow: hidden;
}

.pagination-link.is-current {
  background: #DBEBF4;
  color: #5d6990;
  font-weight: bold;
  border-radius: 6px;
}

.pagination-previous,
.pagination-link,
.pagination-next {
  background: white;
  color: #5d6990;
  text-align: center;
  padding: 0.25em 0.5em;
  display: inline-block;
  text-decoration: none !important;
  margin: 0;
  border-radius: 0;
  border: 0 solid;
  font-size: 0.90rem;
  display: flex;
}

.pagination-previous {
  border-radius: .5em 0 .5em 0;
}

.pagination-previous {
  order: inherit;
}

.pagination-list {
  flex-grow: inherit;
  display: flex;
  flex-direction: row;
}

ul > li.active {
  color: #5fbd68;
  font-weight: bold;
}

ul > li[disabled] {
  cursor: not-allowed;
  background-color: #e6e6e6;
}

@media screen and (max-width: 768px) {
  .pagination-content {
    flex-direction: column;
    float: none;
  }

  .is-medium {
    font-size: 0.75rem;
  }
}
</style>
